import React from "react";
import DragAndDropList from "./DragAndDropList";
import {
  Grid,
  ListItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
  withStyles,
} from "@material-ui/core";

const CamposProntuario = ({
  classes,
  allCampoProntuarioList,
  selectedCampoProntuarioList,
  handleChangeCampoProntuarioList,
  handleChangeCheckbox,
}) => {
  return (
    <div className={classes.content}>
      <div className={classes.selectedItens}>
        <h1>Itens Selecionados</h1>
        <DragAndDropList
          selectedCampoProntuarioList={selectedCampoProntuarioList}
          handleChangeCampoProntuarioList={handleChangeCampoProntuarioList}
          handleChangeCheckbox={handleChangeCheckbox}
        />
      </div>
      <div className={classes.dialogContent}>
        <h1 className={classes.tituloTodosProntuarios}>
          Selecione até 08 itens para mostrar na barra:
        </h1>
        <Grid className={classes.gridContainer} container direction="column">
          {allCampoProntuarioList.map((item, index) => (
            <div className={classes.campoProntuario}>
              <Grid item>
                <ListItem
                  id={`prt-cpr-btn-chk-${index}`}
                  key={item.campo}
                  button
                  onClick={() => handleChangeCheckbox(item)}
                  disabled={item.disabled}
                >
                  <ListItemIcon>
                    <Checkbox checked={item.checked} color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    id={item.campo}
                    primary={item.nome}
                    className={classes.listItemText}
                  />
                </ListItem>
              </Grid>
            </div>
          ))}
        </Grid>
      </div>
    </div>
  );
};

const styles = {
  content: {
    display: "flex",
    width: "100%",
  },
  selectedItens: {
    overflowY: "scroll",
    width: "35%",
    backgroundColor: "white",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    marginRight: "1rem",
    boxShadow:
      "10px 10px 25px rgba(112, 124, 151, 0.05), 15px 15px 35px rgba(112, 124, 151, 0.05)",
    borderRadius: "10px",
    height: "100%",
    "& > h1": {
      fontSize: "16px",
      color: "#505050",
      margin: "24px",
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      overflowY: "hidden",
      width: "65%",
      height: "100%",
      margin: 0,
      backgroundColor: "white",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      boxShadow:
        "10px 10px 25px rgba(112, 124, 151, 0.05), 15px 15px 35px rgba(112, 124, 151, 0.05)",
      borderRadius: "10px",
    },
  },
  tituloTodosProntuarios: {
    color: "#505050",
    fontSize: "16px",
    margin: "24px 0 0 35px",
  },
  gridContainer: {
    margin: "20px 0 0 30px",
    height: "85%",
    width: "30%",
  },
  campoProntuario: {
    display: "flex",
    flexDirection: "row",
    "& > div>div>div:first-child": {
      marginRight: "0px",
    },
  },
  listItemText: {
    padding: "0 8px",
    "& > span": {
      color: "#505050",
      fontWeight: "500",
    },
  },
};

export default withStyles(styles)(CamposProntuario);
